import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import axios from 'axios';
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  Card,
  CardContent,
  Tooltip,
  Box,
  CircularProgress,
  Divider,
  InputAdornment,
  Collapse,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Badge,
  LinearProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  
} from '@material-ui/core';
import {
  DirectionsCar as CarIcon,
  Build as BuildIcon,
  History as HistoryIcon,
  Pageview,
  Warning as WarningIcon,
  LocalShipping as TruckIcon,
  Speed as SpeedIcon,
  Search as SearchIcon,
  Refresh as RefreshIcon,
  ExpandMore as ExpandMoreIcon,
  ChevronRight as ChevronRightIcon,
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Schedule as ScheduleIcon,
  AttachMoney as MoneyIcon,
  CreditCard as RegistrationIcon,
  HelpOutline as HelpIcon,
  MonetizationOn as SoldIcon,
  OpenInNew as OpenInNewIcon,
  AlarmOff as SnoozeIcon,
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from '@material-ui/icons';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { format, differenceInDays } from 'date-fns';
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  header: {
    marginBottom: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    flexGrow: 1,
  },
  searchContainer: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
  },
  searchField: {
    marginRight: theme.spacing(2),
  },
  statsCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  statsIcon: {
    width: 40,
    height: 40,
  },
  cardContent: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  table: {
    minWidth: 650,
  },
  expandCell: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  expandedContent: {
    backgroundColor: theme.palette.background.default,
  },
  vehicleRow: {
    '& > *': {
      borderBottom: 'unset',
    },
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  statusChip: {
    margin: theme.spacing(0.5),
    fontWeight: 'bold',
  },
  goodStatus: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.contrastText,
  },
  warningStatus: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.contrastText,
  },
  criticalStatus: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
  },
  tabContent: {
    padding: theme.spacing(2),
    minHeight: 200,
  },
  listItem: {
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 400,
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  mileageProgress: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  detailSection: {
    marginBottom: theme.spacing(2),
  },
  vehicleIcon: {
    fontSize: 60,
    color: theme.palette.primary.main,
    marginRight: theme.spacing(2),
  },
  dialogHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  costSummary: {
    backgroundColor: theme.palette.grey[100],
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(2),
  },
  noData: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  urgentBadge: {
    '& .MuiBadge-badge': {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
    },
  },
  sectionTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  priorityRow: {
    backgroundColor: theme.palette.warning.light + '20',
  },
  detailsText: {
    fontWeight: '500',
    fontSize: 14,
    color: theme.palette.primary.main,
  }
}));

const FleetOverview = ({ url, user }) => {
  const classes = useStyles();
  const [vehicles, setVehicles] = useState([]);
  const [repairs, setRepairs] = useState([]);
  const [repairRequests, setRepairRequests] = useState([]);
  const [maintenanceHistory, setMaintenanceHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedRows, setExpandedRows] = useState({});
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  // Fault codes state
  const [vehiclesWithFaults, setVehiclesWithFaults] = useState([]);
  const [faultsDialogOpen, setFaultsDialogOpen] = useState(false);
  const [loadingFaults, setLoadingFaults] = useState(false);
  // Registration state
  const [registrationDialogOpen, setRegistrationDialogOpen] = useState(false);
  const [editedplate, setEditedplate] = useState('');
  const [isLookingUp, setIsLookingUp] = useState(false);
  // Disposition state
  const [dispositionOpen, setDispositionOpen] = useState(false);
  const [dispositionLoading, setDispositionLoading] = useState(false);
  const [dispositionVehicle, setDispositionVehicle] = useState(null);
  const [dispositionData, setDispositionData] = useState({
    dispositionType: 'Sold',
    date: format(new Date(), 'yyyy-MM-dd'),
    amount: '',
    buyer: '',
    notes: ''
  });
  // Fault code actions state
  const [faultActions, setFaultActions] = useState({});
  const [showSnoozed, setShowSnoozed] = useState(false);
  const [editingNoteKey, setEditingNoteKey] = useState(null);
  const [editingNoteValue, setEditingNoteValue] = useState('');
  const [repairRequestDialogOpen, setRepairRequestDialogOpen] = useState(false);
  const [repairRequestData, setRepairRequestData] = useState({ faultCode: '', faultDescription: '', notes: '', priority: 'Low', equipmentId: '', vehicleName: '' });
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    try {
      setLoading(true);
      const [vehiclesRes, repairsRes, requestsRes, maintenanceRes, faultsRes] = await Promise.all([
        axios.get(`${url}/api/equipment/listEquipment?forFleetOverview=true`),
        axios.get(`${url}/api/equipment/getRepairs`),
        axios.get(`${url}/api/equipment/repairRequests`),
        axios.get(`${url}/api/equipment/getMaintenanceHistory`),
        axios.get(`${url}/api/equipment/diagnostics/faults`)
      ]);

      setVehicles(vehiclesRes.data.equipment || []);
      setRepairs(repairsRes.data || []);
      setRepairRequests(requestsRes.data.data || []);
      setMaintenanceHistory(maintenanceRes.data || []);
      const faultsData = faultsRes.data.data || [];
      setVehiclesWithFaults(faultsData);

      // Fetch fault actions for all vehicles with faults so snoozed count is accurate on cards
      if (faultsData.length > 0) {
        fetchFaultActionsForVehicles(faultsData.map(v => v._id));
      }
    } catch (error) {
      console.error('Error fetching fleet data:', error);
    } finally {
      setLoading(false);
    }
  };

  // Helper functions
  const getVehicleRepairs = (vehicleId) => {
    return repairs.filter(r => r.equipmentId?._id === vehicleId || r.equipmentId === vehicleId);
  };

  const getVehicleRepairRequests = (vehicleId) => {
    return repairRequests.filter(r => 
      (r.equipmentId?._id === vehicleId || r.equipmentId === vehicleId) && 
      r.status !== 'Converted' && 
      r.status !== 'Rejected'
    );
  };

  const getVehicleMaintenanceHistory = (vehicleId) => {
    return maintenanceHistory.filter(m => 
      m.vehicleId === vehicleId || m.equipmentId === vehicleId
    );
  };

  const getOpenRepairsCount = (vehicleId) => {
    return getVehicleRepairs(vehicleId).filter(r => r.status !== 'Completed').length;
  };

  const getMaintenanceStatus = (vehicle) => {
    if (!vehicle.mileage || !vehicle.nextServiceMileage) return 'unknown';
    const milesUntilService = vehicle.nextServiceMileage - vehicle.mileage;
    
    if (milesUntilService < 0) return 'overdue';
    if (milesUntilService < 500) return 'due-soon';
    return 'good';
  };

  const getMaintenanceChip = (vehicle) => {
    const status = getMaintenanceStatus(vehicle);
    const milesUntilService = vehicle.nextServiceMileage - vehicle.mileage;
    
    switch (status) {
      case 'overdue':
        return (
          <Chip
            size="small"
            label={`Overdue by ${Math.abs(milesUntilService)} mi`}
            className={`${classes.statusChip} ${classes.criticalStatus}`}
            icon={<ErrorIcon />}
          />
        );
      case 'due-soon':
        return (
          <Chip
            size="small"
            label={`Due in ${milesUntilService} mi`}
            className={`${classes.statusChip} ${classes.warningStatus}`}
            icon={<WarningIcon />}
          />
        );
      case 'good':
        return (
          <Chip
            size="small"
            label={`OK (${milesUntilService} mi)`}
            className={`${classes.statusChip} ${classes.goodStatus}`}
            icon={<CheckCircleIcon />}
          />
        );
      default:
        return <Chip size="small" label="No data" />;
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return format(new Date(dateString), 'MM/dd/yyyy');
    } catch {
      return 'N/A';
    }
  };

  // Registration status helpers
  const getRegistrationStatus = (vehicle) => {
    // Only check vehicles (trailers have permanent registration in AZ)
    if (vehicle.type?.toLowerCase() !== 'vehicle') return 'not-applicable';
    if (vehicle.registrationLookupFailed === true || !vehicle.registrationExpirationDate) {
      return 'unknown';
    }
    const expDate = new Date(vehicle.registrationExpirationDate);
    const today = new Date();
    const diffDays = differenceInDays(expDate, today);

    if (diffDays < 0) return 'expired';
    if (diffDays < 15) return 'critical';
    if (diffDays < 30) return 'warning';
    if (diffDays < 60) return 'attention';
    if (diffDays < 90) return 'upcoming';
    return 'good';
  };

  const getRegistrationDaysRemaining = (vehicle) => {
    if (!vehicle.registrationExpirationDate) return null;
    const expDate = new Date(vehicle.registrationExpirationDate);
    const today = new Date();
    return differenceInDays(expDate, today);
  };

  const getRegistrationChip = (vehicle) => {
    const status = getRegistrationStatus(vehicle);
    const days = getRegistrationDaysRemaining(vehicle);

    switch (status) {
      case 'not-applicable':
        return null; // Trailers don't need registration displayed
      case 'expired':
        return (
          <Chip
            size="small"
            label={`Expired ${Math.abs(days)}d ago`}
            className={`${classes.statusChip} ${classes.criticalStatus}`}
            icon={<ErrorIcon />}
          />
        );
      case 'critical':
        return (
          <Chip
            size="small"
            label={`${days}d left`}
            className={`${classes.statusChip} ${classes.criticalStatus}`}
            icon={<ErrorIcon />}
          />
        );
      case 'warning':
        return (
          <Chip
            size="small"
            label={`${days}d left`}
            className={`${classes.statusChip} ${classes.warningStatus}`}
            icon={<WarningIcon />}
          />
        );
      case 'attention':
      case 'upcoming':
        return (
          <Chip
            size="small"
            label={`${days}d left`}
            style={{ backgroundColor: '#FFF3E0', color: '#E65100' }}
            className={classes.statusChip}
          />
        );
      case 'good':
        return (
          <Chip
            size="small"
            label={`OK (${days}d)`}
            className={`${classes.statusChip} ${classes.goodStatus}`}
            icon={<CheckCircleIcon />}
          />
        );
      case 'unknown':
        return (
          <Chip
            size="small"
            label={vehicle.registrationLookupFailed ? "Lookup Failed" : "No Date"}
            style={{ backgroundColor: '#EEEEEE', color: '#757575' }}
            className={classes.statusChip}
            icon={<HelpIcon />}
          />
        );
      default:
        return null;
    }
  };

  const getVehiclesWithRegistrationIssues = () => {
    return vehicles.filter(v => {
      if (v.type?.toLowerCase() !== 'vehicle') return false;
      const status = getRegistrationStatus(v);
      return ['expired', 'critical', 'warning', 'attention', 'upcoming', 'unknown'].includes(status);
    });
  };

  const handleRowExpand = (vehicleId) => {
    setExpandedRows(prev => ({
      ...prev,
      [vehicleId]: !prev[vehicleId]
    }));
  };

  const handleViewDetails = (vehicle) => {
    setSelectedVehicle(vehicle);
    setEditedplate(vehicle.plate || vehicle.licensePlate || '');
    setDetailDialogOpen(true);
    setTabValue(0);
  };

  const handleLookupRegistration = async () => {
    if (!selectedVehicle || !editedplate.trim()) return;

    setIsLookingUp(true);
    try {
      // TODO: Server endpoint not built yet
      // This will hit the server to do plate-to-VIN lookup and check registration
      const response = await axios.post(`${url}/api/equipment/lookupRegistration`, {
        equipmentId: selectedVehicle._id,
        plate: editedplate.trim(),
      });

      if (response.data?.success) {
        // Refresh the data to show updated info
        fetchAllData();
        // Update the selected vehicle with new data
        if (response.data.vehicle) {
          setSelectedVehicle(response.data.vehicle);
        }
      }
    } catch (error) {
      console.log('Error looking up registration:', error);
    } finally {
      setIsLookingUp(false);
    }
  };

  const handleOpenDisposition = (vehicle, e) => {
    if (e) e.stopPropagation();
    setDispositionVehicle(vehicle);
    setDispositionData({
      dispositionType: 'Sold',
      date: format(new Date(), 'yyyy-MM-dd'),
      amount: '',
      buyer: '',
      notes: ''
    });
    setDispositionOpen(true);
  };

  const handleSubmitDisposition = async () => {
    if (!dispositionVehicle?._id) return;
    setDispositionLoading(true);
    try {
      const response = await axios.post(`${url}/api/equipment/markDisposed`, {
        equipmentId: dispositionVehicle._id,
        dispositionType: dispositionData.dispositionType,
        date: dispositionData.date,
        amount: dispositionData.amount ? parseFloat(dispositionData.amount) : null,
        buyer: dispositionData.buyer || null,
        notes: dispositionData.notes || null
      });

      if (response.data.success) {
        setDispositionOpen(false);
        setDetailDialogOpen(false);
        // Refresh the fleet list to remove the disposed vehicle
        fetchAllData();
      } else {
        console.error('Failed to mark equipment as disposed:', response.data.error);
      }
    } catch (error) {
      console.error('Error marking equipment as disposed:', error);
    } finally {
      setDispositionLoading(false);
    }
  };

  const calculateTotalRepairCost = (vehicleId) => {
    return getVehicleRepairs(vehicleId)
      .reduce((total, repair) => total + (repair.cost || 0), 0);
  };

  // Fault code actions helpers
  const fetchFaultActionsForVehicles = async (vehicleIds) => {
    try {
      const results = await Promise.all(
        vehicleIds.map(id => axios.get(`${url}/api/equipment/fault-actions/${id}`))
      );
      const actionsMap = {};
      results.forEach(res => {
        if (res.data?.success && res.data.data) {
          res.data.data.forEach(action => {
            actionsMap[`${action.equipment}_${action.faultCode}`] = action;
          });
        }
      });
      setFaultActions(actionsMap);
    } catch (error) {
      console.error('Error fetching fault actions:', error);
    }
  };

  const handleOpenFaultsDialog = () => {
    setFaultsDialogOpen(true);
    if (vehiclesWithFaults.length > 0) {
      fetchFaultActionsForVehicles(vehiclesWithFaults.map(v => v._id));
    }
  };

  const handleSnoozeFault = async (equipmentId, faultCode) => {
    try {
      const res = await axios.post(`${url}/api/equipment/fault-actions/snooze`, {
        equipmentId, faultCode, snoozeDays: 14
      });
      if (res.data?.success) {
        setFaultActions(prev => ({
          ...prev,
          [`${equipmentId}_${faultCode}`]: res.data.data
        }));
        setSnackbar({ open: true, message: 'Fault code snoozed for 2 weeks', severity: 'success' });
      }
    } catch (error) {
      console.error('Error snoozing fault:', error);
      setSnackbar({ open: true, message: 'Failed to snooze fault code', severity: 'error' });
    }
  };

  const handleSaveNote = async (equipmentId, faultCode) => {
    try {
      const res = await axios.post(`${url}/api/equipment/fault-actions/notes`, {
        equipmentId, faultCode, notes: editingNoteValue
      });
      if (res.data?.success) {
        setFaultActions(prev => ({
          ...prev,
          [`${equipmentId}_${faultCode}`]: res.data.data
        }));
        setEditingNoteKey(null);
        setEditingNoteValue('');
        setSnackbar({ open: true, message: 'Note saved', severity: 'success' });
      }
    } catch (error) {
      console.error('Error saving note:', error);
      setSnackbar({ open: true, message: 'Failed to save note', severity: 'error' });
    }
  };

  const handleOpenRepairRequestDialog = (equipmentId, vehicleName, fault) => {
    setRepairRequestData({
      equipmentId,
      vehicleName,
      faultCode: fault.obdCode || fault.code,
      faultDescription: fault.description || '',
      notes: '',
      priority: fault.severity === 'Critical' ? 'High' : fault.severity === 'Warning' ? 'Medium' : 'Low'
    });
    setRepairRequestDialogOpen(true);
  };

  const handleSubmitRepairRequest = async () => {
    try {
      const res = await axios.post(`${url}/api/equipment/fault-actions/repair-request`, {
        equipmentId: repairRequestData.equipmentId,
        faultCode: repairRequestData.faultCode,
        faultDescription: repairRequestData.faultDescription,
        notes: repairRequestData.notes,
        priority: repairRequestData.priority
      });
      console.log('handleSubmitRepairRequest', res)
      if (res.data?.success) {
        setRepairRequestDialogOpen(false);
        setSnackbar({ open: true, message: 'Repair request created', severity: 'success' });
        // Refresh repair requests
        const requestsRes = await axios.get(`${url}/api/equipment/repairRequests`);
        setRepairRequests(requestsRes.data.data || []);
      }
    } catch (error) {
      console.error('Error creating repair request:', error);
      setSnackbar({ open: true, message: 'Failed to create repair request', severity: 'error' });
    }
  };

  const isFaultSnoozed = (equipmentId, faultCode) => {
    const action = faultActions[`${equipmentId}_${faultCode}`];
    return action?.snoozedUntil && new Date(action.snoozedUntil) > new Date();
  };

  const getSnoozedCount = () => {
    let count = 0;
    vehiclesWithFaults.forEach(vehicle => {
      vehicle.activeFaultCodes?.forEach(fault => {
        const code = fault.obdCode || fault.code;
        if (isFaultSnoozed(vehicle._id, code)) count++;
      });
    });
    return count;
  };

  // Priority sorting function
  const getVehiclePriority = (vehicle) => {
    const maintenanceStatus = getMaintenanceStatus(vehicle);
    const openRepairRequests = getVehicleRepairRequests(vehicle._id).length;
    const openRepairs = getOpenRepairsCount(vehicle._id);
    
    // Priority scoring:
    // - Overdue maintenance: 1000 points
    // - Each open repair request: 100 points
    // - Each open repair: 10 points
    // - Due soon maintenance: 50 points
    
    let priority = 0;
    
    if (maintenanceStatus === 'overdue') {
      priority += 1000;
    } else if (maintenanceStatus === 'due-soon') {
      priority += 50;
    }
    
    priority += openRepairRequests * 100;
    priority += openRepairs * 10;
    
    return priority;
  };

  // Filter and sort vehicles
  const filteredAndSortedVehicles = vehicles
    ?.filter(vehicle =>
      vehicle.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      vehicle.number?.toString().includes(searchTerm) ||
      vehicle.manufacturer?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      vehicle.model?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    ?.sort((a, b) => {
      // Sort by priority (higher priority first)
      return getVehiclePriority(b) - getVehiclePriority(a);
    });

  // Calculate statistics
  const vehiclesWithRegIssues = getVehiclesWithRegistrationIssues();
  const expiredRegistrations = vehicles?.filter(v => getRegistrationStatus(v) === 'expired').length || 0;
  const stats = {
    totalVehicles: vehicles?.length,
    activeVehicles: vehicles?.filter(v => (v.isActive && !getVehicleRepairs(v._id).some(r => r.outOfService && r.status !== 'Completed'))).length,
    maintenanceDue: vehicles?.filter(v => getMaintenanceStatus(v) === 'due-soon' || getMaintenanceStatus(v) === 'overdue').length,
    openRepairs: repairs.filter(r => r.status !== 'Completed').length,
    openRepairRequests: repairRequests.filter(r => r.status !== 'Converted' && r.status !== 'Rejected').length,
    vehiclesWithFaults: vehiclesWithFaults?.length || 0,
    totalFaultCodes: vehiclesWithFaults?.reduce((sum, v) => sum + (v.activeFaultCount || 0), 0) || 0,
    snoozedFaultCodes: getSnoozedCount(),
    registrationIssues: vehiclesWithRegIssues?.length || 0,
    expiredRegistrations,
  };

  const VehicleIcon = ({ type }) => {
    return type?.toLowerCase() === 'truck' ? 
      <TruckIcon className={classes.vehicleIcon} /> : 
      <CarIcon className={classes.vehicleIcon} />;
  };

  // Check if vehicle should be highlighted
  const shouldHighlightRow = (vehicle) => {
    const maintenanceStatus = getMaintenanceStatus(vehicle);
    const hasOpenRepairRequests = getVehicleRepairRequests(vehicle._id).length > 0;
    const hasOpenRepairs = getOpenRepairsCount(vehicle._id) > 0;
    
    return maintenanceStatus === 'overdue' || hasOpenRepairRequests || hasOpenRepairs;
  };

  return (
    <Container className={classes.root}>
      {/* Header */}
      <Box className={classes.header}>
        <Typography variant="h4" className={classes.title}>
          Fleet Overview
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<RefreshIcon />}
          onClick={fetchAllData}
        >
          Refresh
        </Button>
      </Box>

      {/* Statistics Cards */}
      <Grid container spacing={3} style={{ marginBottom: 24 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.statsCard}>
            <CardContent className={classes.cardContent}>
              <div>
                <Typography color="textSecondary" gutterBottom>
                  Total Vehicles
                </Typography>
                <Typography variant="h4">
                  {stats.totalVehicles} 
                </Typography>
                <div className={classes.detailsText}>
                    {stats.activeVehicles} Active
                </div>
              </div>
              <CarIcon className={classes.statsIcon} color="primary" />
            </CardContent>
          </Card>
        </Grid>
        
        {/* <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.statsCard}>
            <CardContent className={classes.cardContent}>
              <div>
                <Typography color="textSecondary" gutterBottom>
                  Active Vehicles
                </Typography>
                <Typography variant="h4">
                  {stats.activeVehicles}
                </Typography>
              </div>
              <CheckCircleIcon className={classes.statsIcon} style={{ color: '#4CAF50' }} />
            </CardContent>
          </Card>
        </Grid> */}

        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.statsCard}>
            <CardContent className={classes.cardContent}>
              <div>
                <Typography color="textSecondary" gutterBottom>
                  Maintenance Due
                </Typography>
                <Typography variant="h4">
                  {stats.maintenanceDue}
                </Typography>
              </div>
              <ScheduleIcon className={classes.statsIcon} style={{ color: '#FF9800' }} />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.statsCard}>
            <CardContent className={classes.cardContent}>
              <div>
                <Typography color="textSecondary" gutterBottom>
                  Open Repairs
                </Typography>
                <Typography variant="h4">
                  {stats.openRepairs}
                </Typography>
              </div>
              <BuildIcon className={classes.statsIcon} style={{ color: '#2196F3' }} />
            </CardContent>
          </Card>
        </Grid>

        {/* New Open Repair Requests Card */}
        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.statsCard}>
            <CardContent className={classes.cardContent}>
              <div>
                <Typography color="textSecondary" gutterBottom>
                  Open Repair Requests
                </Typography>
                <Typography variant="h4">
                  {stats.openRepairRequests}
                </Typography>
              </div>
              <AssignmentIcon className={classes.statsIcon} style={{ color: '#9C27B0' }} />
            </CardContent>
          </Card>
        </Grid>

        {/* Active Fault Codes Card */}
        <Grid item xs={12} sm={6} md={3}>
          <Card
            className={classes.statsCard}
            style={{ cursor: stats.vehiclesWithFaults > 0 ? 'pointer' : 'default' }}
            onClick={() => stats.vehiclesWithFaults > 0 && handleOpenFaultsDialog()}
          >
            <CardContent className={classes.cardContent}>
              <div>
                <Typography color="textSecondary" gutterBottom>
                  Active Fault Codes
                </Typography>
                <Typography variant="h4" style={{ color: stats.vehiclesWithFaults > 0 ? '#f44336' : 'inherit' }}>
                  {stats.totalFaultCodes - stats.snoozedFaultCodes}
                </Typography>
                <div className={classes.detailsText} style={{ color: stats.vehiclesWithFaults > 0 ? '#f44336' : '#666' }}>
                  {stats.vehiclesWithFaults} vehicle{stats.vehiclesWithFaults !== 1 ? 's' : ''} affected
                </div>
                {stats.snoozedFaultCodes > 0 && (
                  <div className={classes.detailsText} style={{ color: '#9e9e9e', fontSize: 12 }}>
                    {stats.snoozedFaultCodes} snoozed
                  </div>
                )}
              </div>
              <Badge badgeContent={stats.vehiclesWithFaults} color="error">
                <ErrorIcon className={classes.statsIcon} style={{ color: stats.vehiclesWithFaults > 0 ? '#f44336' : '#9e9e9e' }} />
              </Badge>
            </CardContent>
          </Card>
        </Grid>

        {/* Registration Issues Card */}
        <Grid item xs={12} sm={6} md={3}>
          <Card
            className={classes.statsCard}
            style={{ cursor: stats.registrationIssues > 0 ? 'pointer' : 'default' }}
            onClick={() => stats.registrationIssues > 0 && setRegistrationDialogOpen(true)}
          >
            <CardContent className={classes.cardContent}>
              <div>
                <Typography color="textSecondary" gutterBottom>
                  Registration Issues
                </Typography>
                <Typography variant="h4" style={{ color: stats.expiredRegistrations > 0 ? '#f44336' : stats.registrationIssues > 0 ? '#FF9800' : 'inherit' }}>
                  {stats.registrationIssues}
                </Typography>
                <div className={classes.detailsText} style={{ color: stats.expiredRegistrations > 0 ? '#f44336' : '#666' }}>
                  {stats.expiredRegistrations > 0 ? `${stats.expiredRegistrations} expired` : 'vehicles need attention'}
                </div>
              </div>
              <RegistrationIcon
                className={classes.statsIcon}
                style={{ color: stats.expiredRegistrations > 0 ? '#f44336' : stats.registrationIssues > 0 ? '#FF9800' : '#9e9e9e' }}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Search */}
      <Paper className={classes.searchContainer}>
        <TextField
          className={classes.searchField}
          variant="outlined"
          placeholder="Search by name, number, make, or model..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          style={{ width: '100%' }}
        />
      </Paper>

      {/* Vehicles Table */}
      {loading ? (
        <div className={classes.loadingContainer}>
          <CircularProgress />
        </div>
      ) : filteredAndSortedVehicles.length === 0 ? (
        <Paper className={classes.emptyState}>
          <Typography variant="h6">
            No vehicles found
          </Typography>
        </Paper>
      ) : (
        <TableContainer component={Paper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>Vehicle</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Year/Make/Model</TableCell>
                <TableCell align="center">Mileage</TableCell>
                <TableCell align="center">Maintenance</TableCell>
                <TableCell align="center">Registration</TableCell>
                <TableCell align="center">Open Repairs</TableCell>
                <TableCell align="center">Repair Requests</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredAndSortedVehicles.map((vehicle) => (
                <React.Fragment key={vehicle._id}>
                  <TableRow 
                    className={`${classes.vehicleRow} ${shouldHighlightRow(vehicle) ? classes.priorityRow : ''}`}
                  >
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => handleRowExpand(vehicle._id)}
                      >
                        {expandedRows[vehicle._id] ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <Box display="flex" alignItems="center">
                        <strong>{vehicle.name} #{vehicle.number}</strong>
                        <Tooltip title="Open equipment details in new tab">
                          <IconButton
                            size="small"
                            component={Link}
                            to={`/equipment/details/${vehicle._id}`}
                            target="_blank"
                            onClick={(e) => e.stopPropagation()}
                            style={{ marginLeft: 4 }}
                          >
                            <OpenInNewIcon fontSize="small" style={{ fontSize: 14 }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell>{vehicle.type}</TableCell>
                    <TableCell>
                      {vehicle.year} {vehicle.manufacturer} {vehicle.model}
                    </TableCell>
                    <TableCell align="center">
                      {vehicle.mileage ? vehicle.mileage.toLocaleString() : 'N/A'}
                    </TableCell>
                    <TableCell align="center">
                      {getMaintenanceChip(vehicle)}
                    </TableCell>
                    <TableCell align="center">
                      {getRegistrationChip(vehicle)}
                    </TableCell>
                    <TableCell align="center">
                      <Badge
                        badgeContent={getOpenRepairsCount(vehicle._id)}
                        color="primary"
                        className={getOpenRepairsCount(vehicle._id) > 0 ? classes.urgentBadge : ''}
                      >
                        <BuildIcon />
                      </Badge>
                    </TableCell>
                    <TableCell align="center">
                      <Badge
                        badgeContent={getVehicleRepairRequests(vehicle._id).length}
                        color="secondary"
                      >
                        <AssignmentIcon />
                      </Badge>
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="View Details">
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => handleViewDetails(vehicle)}
                        >
                          <Pageview />
                        </IconButton>
                      </Tooltip>

                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.expandCell} colSpan={10}>
                      <Collapse in={expandedRows[vehicle._id]} timeout="auto" unmountOnExit>
                        <Box className={classes.expandedContent} p={3}>
                          <Grid container spacing={3}>
                            {/* Quick Info */}
                            <Grid item xs={12} md={4}>
                              <Typography className={classes.sectionTitle}>
                                Vehicle Information
                              </Typography>
                              <Typography variant="body2">
                                <strong>VIN:</strong> {vehicle.vin || 'N/A'}
                              </Typography>
                              <Typography variant="body2">
                                <strong>License Plate:</strong> {vehicle.plate || vehicle.licensePlate || 'N/A'}
                              </Typography>
                              <Typography variant="body2">
                                <strong>Division:</strong> {vehicle.division || 'N/A'}
                              </Typography>
                              <Typography variant="body2">
                                <strong>Assigned Driver:</strong> {vehicle.assignedDriverName || 'Unassigned'}
                              </Typography>
                              {vehicle.type?.toLowerCase() === 'vehicle' && (
                                <Typography variant="body2">
                                  <strong>Registration:</strong> {vehicle.registrationExpirationDate ? formatDate(vehicle.registrationExpirationDate) : 'N/A'}
                                  {getRegistrationStatus(vehicle) === 'expired' && (
                                    <span style={{ color: '#f44336', marginLeft: 8 }}>(Expired)</span>
                                  )}
                                </Typography>
                              )}
                            </Grid>

                            {/* Recent Repairs */}
                            <Grid item xs={12} md={4}>
                              <Typography className={classes.sectionTitle}>
                                Recent Repairs
                              </Typography>
                              {getVehicleRepairs(vehicle._id).slice(0, 3).length > 0 ? (
                                <List dense>
                                  {getVehicleRepairs(vehicle._id).slice(0, 3).map((repair, idx) => (
                                    <ListItem key={idx} className={classes.listItem}>
                                      <ListItemIcon>
                                        <BuildIcon fontSize="small" />
                                      </ListItemIcon>
                                      <ListItemText
                                        primary={repair.description}
                                        secondary={`${formatDate(repair.date)} - ${repair.status}`}
                                      />
                                    </ListItem>
                                  ))}
                                </List>
                              ) : (
                                <Typography variant="body2" className={classes.noData}>
                                  No recent repairs
                                </Typography>
                              )}
                            </Grid>

                            {/* Maintenance Progress */}
                            <Grid item xs={12} md={4}>
                              <Typography className={classes.sectionTitle}>
                                Maintenance Progress
                              </Typography>
                              {vehicle.mileage && vehicle.nextServiceMileage ? (
                                <>
                                  <Typography variant="body2">
                                    Current: {vehicle.mileage.toLocaleString()} mi
                                  </Typography>
                                  <Typography variant="body2">
                                    Next Service: {vehicle.nextServiceMileage.toLocaleString()} mi
                                  </Typography>
                                  <LinearProgress
                                    variant="determinate"
                                    value={Math.min(100, (vehicle.mileage / vehicle.nextServiceMileage) * 100)}
                                    className={classes.mileageProgress}
                                    color={getMaintenanceStatus(vehicle) === 'overdue' ? 'secondary' : 'primary'}
                                  />
                                </>
                              ) : (
                                <Typography variant="body2" className={classes.noData}>
                                  No maintenance data available
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Detail Dialog */}
      <Dialog
        open={detailDialogOpen}
        onClose={() => setDetailDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {selectedVehicle && (
            <Box className={classes.dialogHeader}>
              <VehicleIcon type={selectedVehicle.type} />
              <div>
                <Typography variant="h6">
                  <Link 
                    style={{pointer: 'cursor', color: '#516876', fontWeight: 600, fontSize: 18 }}
                    target="_blank"
                    to={{ 
                      pathname: `/equipment/details/${selectedVehicle._id}`,
                                // search: '?sort=name',
                                // hash: '#the-hash',
                                state: {item: selectedVehicle, stuff: 'Search Engine'}
                     }}
                    
                  >{selectedVehicle.name} #{selectedVehicle.number} </Link>
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  {selectedVehicle.year} {selectedVehicle.manufacturer} {selectedVehicle.model}
                </Typography>
              </div>
            </Box>
          )}
        </DialogTitle>
        <DialogContent>
          {selectedVehicle && (
            <>
              <Tabs
                value={tabValue}
                onChange={(e, newValue) => setTabValue(newValue)}
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab label="Vehicle Info" />
                <Tab label="Repair History" />
                <Tab label="Maintenance History" />
                <Tab label="Repair Requests" />
              </Tabs>

              {/* Vehicle Info Tab */}
              {tabValue === 0 && (
                <Box className={classes.tabContent}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body2" color="textSecondary">VIN</Typography>
                      <Typography variant="body1" style={{ fontFamily: 'monospace' }}>
                        {selectedVehicle.vin || 'N/A'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body2" color="textSecondary">Current Mileage</Typography>
                      <Typography variant="body1">
                        {selectedVehicle.mileage ? selectedVehicle.mileage.toLocaleString() : 'N/A'} miles
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body2" color="textSecondary">Next Service</Typography>
                      <Typography variant="body1">
                        {selectedVehicle.nextServiceMileage ? selectedVehicle.nextServiceMileage.toLocaleString() : 'N/A'} miles
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body2" color="textSecondary">Division</Typography>
                      <Typography variant="body1">{selectedVehicle.division || 'N/A'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body2" color="textSecondary">Assigned Driver</Typography>
                      <Typography variant="body1">{selectedVehicle.assignedDriverName || 'Unassigned'}</Typography>
                    </Grid>
                  </Grid>

                  {/* Registration Section */}
                  {selectedVehicle.type?.toLowerCase() === 'vehicle' && (
                    <Box
                      mt={3}
                      p={2}
                      style={{
                        backgroundColor: getRegistrationStatus(selectedVehicle) === 'expired' ? '#ffebee' :
                          getRegistrationStatus(selectedVehicle) === 'unknown' ? '#f5f5f5' : '#f5f5f5',
                        borderRadius: 8,
                        border: getRegistrationStatus(selectedVehicle) === 'expired' ? '1px solid #ffcdd2' : '1px solid #e0e0e0'
                      }}
                    >
                      <Typography variant="h6" gutterBottom style={{ display: 'flex', alignItems: 'center' }}>
                        <RegistrationIcon style={{ marginRight: 8, color: '#666' }} />
                        Registration Details
                        <Box ml={2}>
                          {getRegistrationChip(selectedVehicle)}
                        </Box>
                      </Typography>

                      <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Plate Number"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={editedplate}
                            onChange={(e) => setEditedplate(e.target.value.toUpperCase())}
                            placeholder="Enter plate number"
                            InputProps={{
                              style: { fontFamily: 'monospace', fontWeight: 600 }
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleLookupRegistration}
                            disabled={!editedplate.trim() || isLookingUp}
                            startIcon={isLookingUp ? <CircularProgress size={20} color="inherit" /> : <SearchIcon />}
                          >
                            {isLookingUp ? 'Looking up...' : 'Lookup Registration'}
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" color="textSecondary">Registration Expires</Typography>
                          <Typography variant="body1" style={{
                            color: getRegistrationStatus(selectedVehicle) === 'expired' ? '#f44336' : 'inherit',
                            fontWeight: getRegistrationStatus(selectedVehicle) === 'expired' ? 600 : 400
                          }}>
                            {selectedVehicle.registrationExpirationDate
                              ? formatDate(selectedVehicle.registrationExpirationDate)
                              : 'Not on file'}
                            {getRegistrationStatus(selectedVehicle) === 'expired' && ' (EXPIRED)'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" color="textSecondary">Days Remaining</Typography>
                          <Typography variant="body1" style={{
                            color: getRegistrationStatus(selectedVehicle) === 'expired' ? '#f44336' :
                              getRegistrationStatus(selectedVehicle) === 'critical' ? '#f44336' :
                              getRegistrationStatus(selectedVehicle) === 'warning' ? '#FF9800' : 'inherit',
                            fontWeight: 600
                          }}>
                            {(() => {
                              const days = getRegistrationDaysRemaining(selectedVehicle);
                              if (days === null) return 'Unknown';
                              if (days < 0) return `${Math.abs(days)} days overdue`;
                              return `${days} days`;
                            })()}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  )}

                  <Box className={classes.costSummary}>
                    <Typography variant="h6" gutterBottom>
                      <MoneyIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
                      Cost Summary
                    </Typography>
                    <Typography variant="body1">
                      <strong>Total Repair Costs:</strong> ${calculateTotalRepairCost(selectedVehicle._id).toLocaleString()}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Based on {getVehicleRepairs(selectedVehicle._id).length} repairs
                    </Typography>
                  </Box>
                </Box>
              )}

              {/* Repair History Tab */}
              {tabValue === 1 && (
                <Box className={classes.tabContent}>
                  {getVehicleRepairs(selectedVehicle._id).length > 0 ? (
                    <List>
                      {getVehicleRepairs(selectedVehicle._id).map((repair, idx) => (
                        <ListItem key={idx} className={classes.listItem}>
                          <ListItemIcon>
                            <BuildIcon />
                          </ListItemIcon>
                          <ListItemText
                            primary={repair.description}
                            secondary={
                              <span>
                                {formatDate(repair.date)} | Status: {repair.status} | 
                                Cost: ${repair.cost || 0} | Priority: {repair.priority}
                              </span>
                            }
                          />
                          {repair.outOfService && (
                            <Chip
                              size="small"
                              label="OOS"
                              color="secondary"
                            />
                          )}
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography className={classes.noData}>
                      No repair history available
                    </Typography>
                  )}
                </Box>
              )}

              {/* Maintenance History Tab */}
              {tabValue === 2 && (
                <Box className={classes.tabContent}>
                  {getVehicleMaintenanceHistory(selectedVehicle._id).length > 0 ? (
                    <List>
                      {getVehicleMaintenanceHistory(selectedVehicle._id).reverse().map((maintenance, idx) => (
                        <ListItem key={idx} className={classes.listItem}>
                          <ListItemIcon>
                            <ScheduleIcon />
                          </ListItemIcon>
                          <ListItemText
                            primary={`Service at ${maintenance.currentMileage?.toLocaleString() || 'N/A'} miles`}
                            secondary={
                              <span>
                                {formatDate(maintenance.serviceDate)} | 
                                Next: {maintenance.nextServiceMileage?.toLocaleString() || 'N/A'} miles
                              </span>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography className={classes.noData}>
                      No maintenance history available
                    </Typography>
                  )}
                </Box>
              )}

              {/* Repair Requests Tab */}
              {tabValue === 3 && (
                <Box className={classes.tabContent}>
                  {getVehicleRepairRequests(selectedVehicle._id).length > 0 ? (
                    <List>
                      {getVehicleRepairRequests(selectedVehicle._id).reverse().map((request, idx) => (
                        <ListItem key={idx} className={classes.listItem}>
                          <ListItemIcon>
                            <AssignmentIcon />
                          </ListItemIcon>
                          <ListItemText
                            primary={request.reportedIssues.map(i => i.name).join(', ')}
                            secondary={
                              <span>
                                {formatDate(request.created_at)} | 
                                Status: {request.status} | 
                                Reported by: {request.reportedByName}
                              </span>
                            }
                          />
                          <Chip
                            size="small"
                            label={request.status}
                            color={request.status === 'Under Review' ? 'primary' : 'default'}
                          />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography className={classes.noData}>
                      No open repair requests
                    </Typography>
                  )}
                </Box>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleOpenDisposition(selectedVehicle)}
            color="secondary"
            startIcon={<SoldIcon />}
            style={{ marginRight: 'auto' }}
          >
            Mark as Sold/Donated
          </Button>
          <Button onClick={() => setDetailDialogOpen(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Active Faults Dialog */}
      <Dialog
        open={faultsDialogOpen}
        onClose={() => setFaultsDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box display="flex" alignItems="center">
              <ErrorIcon style={{ color: '#f44336', marginRight: 8 }} />
              <Typography variant="h6">
                Vehicles with Active Fault Codes ({vehiclesWithFaults.length})
              </Typography>
            </Box>
            {getSnoozedCount() > 0 && (
              <Button
                size="small"
                startIcon={showSnoozed ? <VisibilityOffIcon /> : <VisibilityIcon />}
                onClick={() => setShowSnoozed(!showSnoozed)}
                style={{ textTransform: 'none' }}
              >
                {showSnoozed ? 'Hide' : 'Show'} {getSnoozedCount()} snoozed
              </Button>
            )}
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {vehiclesWithFaults.length === 0 ? (
            <Box textAlign="center" py={4}>
              <CheckCircleIcon style={{ fontSize: 60, color: '#4caf50', marginBottom: 16 }} />
              <Typography variant="h6" color="textSecondary">
                No active fault codes detected
              </Typography>
              <Typography variant="body2" color="textSecondary">
                All vehicles are reporting healthy diagnostics
              </Typography>
            </Box>
          ) : (
            <List>
              {vehiclesWithFaults.map((vehicle) => {
                const visibleFaults = vehicle.activeFaultCodes?.filter(fault => {
                  const code = fault.obdCode || fault.code;
                  const snoozed = isFaultSnoozed(vehicle._id, code);
                  return showSnoozed || !snoozed;
                });
                console.log('vehicle', vehicle)
                if (!visibleFaults || visibleFaults.length === 0) return null;
                return (
                <React.Fragment key={vehicle._id}>
                  <ListItem
                    className={classes.listItem}
                    style={{ flexDirection: 'column', alignItems: 'flex-start', marginBottom: 16, padding: 16, backgroundColor: '#fff5f5' }}
                  >
                    <Box display="flex" justifyContent="space-between" width="100%" alignItems="center" mb={1}>
                      <Box display="flex" alignItems="center">
                        <CarIcon style={{ marginRight: 8, color: '#666' }} />
                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                          {vehicle.vehicleInfo?.name || 'Unknown'} #{vehicle.vehicleInfo?.number || ''}
                        </Typography>
                      </Box>
                      <Chip
                        size="small"
                        label={`${vehicle.activeFaultCount} fault${vehicle.activeFaultCount !== 1 ? 's' : ''}`}
                        style={{ backgroundColor: '#f44336', color: 'white' }}
                      />
                    </Box>
                    <Typography variant="caption" color="textSecondary" style={{ marginBottom: 8 }}>
                      {vehicle.vehicleInfo?.year} {vehicle.vehicleInfo?.make} {vehicle.vehicleInfo?.model}
                      {vehicle.capturedAt && ` • Last checked: ${format(new Date(vehicle.capturedAt), 'MM/dd/yyyy h:mm a')}`}
                    </Typography>
                    <Divider style={{ width: '100%', margin: '8px 0' }} />
                    <Box width="100%">
                      {visibleFaults.map((fault, idx) => {
                        const faultCode = fault.obdCode || fault.code;
                        const actionKey = `${vehicle._id}_${faultCode}`;
                        const action = faultActions[actionKey];
                        const snoozed = isFaultSnoozed(vehicle._id, faultCode);
                        const isEditingThis = editingNoteKey === actionKey;

                        return (
                        <Box
                          key={idx}
                          mb={1}
                          p={1.5}
                          bgcolor={snoozed ? '#f5f5f5' : 'white'}
                          borderRadius={1}
                          border={snoozed ? '1px solid #e0e0e0' : '1px solid #ffcdd2'}
                          style={snoozed ? { opacity: 0.7 } : {}}
                        >
                          <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                            <Box flex={1}>
                              <Box display="flex" alignItems="center" mb={0.5}>
                                <Chip
                                  size="small"
                                  label={faultCode}
                                  style={{
                                    backgroundColor: snoozed ? '#9e9e9e' : fault.severity === 'Critical' ? '#f44336' :
                                      fault.severity === 'Warning' ? '#ff9800' : '#2196f3',
                                    color: 'white',
                                    fontWeight: 600,
                                    marginRight: 8
                                  }}
                                />
                                {fault.severity && (
                                  <Typography variant="caption" color="textSecondary">
                                    {fault.severity}
                                  </Typography>
                                )}
                                {snoozed && (
                                  <Chip size="small" label={`Snoozed until ${format(new Date(action.snoozedUntil), 'MM/dd')}`} style={{ marginLeft: 8, fontSize: 11 }} />
                                )}
                              </Box>
                              <Typography variant="body2" style={{ fontWeight: 500 }}>
                                {fault.description}
                              </Typography>
                              {fault.recommendation && (
                                <Typography variant="caption" color="textSecondary" display="block" style={{ marginTop: 4 }}>
                                  <em>{fault.recommendation}</em>
                                </Typography>
                              )}
                              {fault.effectOnComponent && (
                                <Typography variant="caption" style={{ color: '#ff9800', marginTop: 4 }} display="block">
                                  {fault.effectOnComponent}
                                </Typography>
                              )}
                              {/* Saved note display */}
                              {action?.notes && !isEditingThis && (
                                <Box mt={1} p={1} bgcolor="#fff8e1" borderRadius={4} border="1px solid #ffe082">
                                  <Typography variant="caption" style={{ fontWeight: 600 }}>Note:</Typography>
                                  <Typography variant="caption" display="block">{action.notes}</Typography>
                                  {action.notesUpdatedByName && (
                                    <Typography variant="caption" color="textSecondary">
                                      — {action.notesUpdatedByName}{action.notesUpdatedAt && `, ${format(new Date(action.notesUpdatedAt), 'MM/dd h:mm a')}`}
                                    </Typography>
                                  )}
                                </Box>
                              )}
                              {/* Inline note editor */}
                              {isEditingThis && (
                                <Box mt={1} display="flex" alignItems="center">
                                  <TextField
                                    size="small"
                                    variant="outlined"
                                    placeholder="Add a note..."
                                    value={editingNoteValue}
                                    onChange={(e) => setEditingNoteValue(e.target.value)}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter') handleSaveNote(vehicle._id, faultCode);
                                      if (e.key === 'Escape') setEditingNoteKey(null);
                                    }}
                                    style={{ flex: 1, marginRight: 8 }}
                                    autoFocus
                                  />
                                  <Button size="small" variant="contained" color="primary" onClick={() => handleSaveNote(vehicle._id, faultCode)}>
                                    Save
                                  </Button>
                                  <Button size="small" onClick={() => setEditingNoteKey(null)} style={{ marginLeft: 4 }}>
                                    Cancel
                                  </Button>
                                </Box>
                              )}
                            </Box>
                            <Box display="flex" flexDirection="column" alignItems="center" ml={2}>
                              {fault.timesLogged > 1 && (
                                <Typography variant="caption" style={{ color: '#f44336' }}>
                                  Logged {fault.timesLogged}x
                                </Typography>
                              )}
                              {fault.riskOfBreakdown != null && (
                                <Typography variant="caption" display="block" color="textSecondary">
                                  Risk: {fault.riskOfBreakdown.toFixed(1)}%
                                </Typography>
                              )}
                              {/* Action buttons */}
                              <Box display="flex" mt={1}>
                                <Tooltip title={snoozed ? 'Already snoozed' : 'Snooze for 2 weeks'}>
                                  <span>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleSnoozeFault(vehicle._id, faultCode)}
                                      disabled={snoozed}
                                      style={{ color: snoozed ? '#bdbdbd' : '#ff9800' }}
                                    >
                                      <SnoozeIcon fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                                <Tooltip title="Add/Edit Note">
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      setEditingNoteKey(actionKey);
                                      setEditingNoteValue(action?.notes || '');
                                    }}
                                    style={{ color: '#2196f3' }}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Create Repair Request">
                                  <IconButton
                                    size="small"
                                    onClick={() => handleOpenRepairRequestDialog(
                                      vehicle.equipment,
                                      `${vehicle.vehicleInfo?.name || 'Unknown'} #${vehicle.vehicleInfo?.number || ''}`,
                                      fault
                                    )}
                                    style={{ color: '#4caf50' }}
                                  >
                                    <BuildIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                        );
                      })}
                    </Box>
                  </ListItem>
                </React.Fragment>
                );
              })}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFaultsDialogOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Create Repair Request from Fault Code Dialog */}
      <Dialog
        open={repairRequestDialogOpen}
        onClose={() => setRepairRequestDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <BuildIcon style={{ marginRight: 8, color: '#4caf50' }} />
            <Typography variant="h6">Create Repair Request</Typography>
          </Box>
          <Typography variant="body2" color="textSecondary">
            {repairRequestData.vehicleName}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} style={{ marginTop: 4 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Fault Code"
                variant="outlined"
                value={repairRequestData.faultCode}
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Priority</InputLabel>
                <Select
                  value={repairRequestData.priority}
                  onChange={(e) => setRepairRequestData({ ...repairRequestData, priority: e.target.value })}
                  label="Priority"
                >
                  <MenuItem value="Low">Low</MenuItem>
                  <MenuItem value="Medium">Medium</MenuItem>
                  <MenuItem value="High">High</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                variant="outlined"
                value={repairRequestData.faultDescription}
                InputProps={{ readOnly: true }}
                multiline
                rows={2}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Notes"
                variant="outlined"
                multiline
                rows={3}
                value={repairRequestData.notes}
                onChange={(e) => setRepairRequestData({ ...repairRequestData, notes: e.target.value })}
                placeholder="Add any additional details for the mechanic..."
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRepairRequestDialogOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmitRepairRequest}
            startIcon={<BuildIcon />}
          >
            Submit Request
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Registration Issues Dialog */}
      <Dialog
        open={registrationDialogOpen}
        onClose={() => setRegistrationDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <RegistrationIcon style={{ color: '#FF9800', marginRight: 8 }} />
            <Typography variant="h6">
              Vehicles with Registration Issues ({vehiclesWithRegIssues.length})
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {vehiclesWithRegIssues.length === 0 ? (
            <Box textAlign="center" py={4}>
              <CheckCircleIcon style={{ fontSize: 60, color: '#4caf50', marginBottom: 16 }} />
              <Typography variant="h6" color="textSecondary">
                No registration issues
              </Typography>
              <Typography variant="body2" color="textSecondary">
                All vehicle registrations are up to date
              </Typography>
            </Box>
          ) : (
            <List>
              {vehiclesWithRegIssues
                .sort((a, b) => {
                  // Sort by urgency: expired first, then by days remaining
                  const daysA = getRegistrationDaysRemaining(a) ?? 9999;
                  const daysB = getRegistrationDaysRemaining(b) ?? 9999;
                  return daysA - daysB;
                })
                .map((vehicle) => {
                  const status = getRegistrationStatus(vehicle);
                  const days = getRegistrationDaysRemaining(vehicle);
                  const isExpired = status === 'expired';
                  const isUnknown = status === 'unknown';
                  const handleOpenVehicleDetails = () => {
                    console.log('handleOpenVehicleDetails', vehicle)
                    window.open(`/equipment/details/${vehicle._id}`, "_blank")
                  }
                  return (
                    <ListItem
                      key={vehicle._id}
                      className={classes.listItem}
                      style={{
                        marginBottom: 12,
                        padding: 16,
                        backgroundColor: isExpired ? '#ffebee' : isUnknown ? '#f5f5f5' : '#fff8e1'
                      }}
                    >
                      <ListItemIcon>
                        <CarIcon style={{ color: isExpired ? '#f44336' : isUnknown ? '#9e9e9e' : '#FF9800' }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                        
                            <Typography variant="subtitle1" style={{ fontWeight: 600, color: '#769ba2', cursor: 'pointer' }}
                               onClick={handleOpenVehicleDetails}
                            >
                            {vehicle.name} #{vehicle.number}
                          </Typography>
                        }
                        secondary={
                          <>
                            <Typography variant="body2" color="textSecondary">
                              {vehicle.year} {vehicle.manufacturer} {vehicle.model}
                            </Typography>
                            {vehicle.plate && (
                              <Typography variant="body2" color="textSecondary">
                                Plate: <strong>{vehicle.plate}</strong>
                              </Typography>
                            )}
                            {vehicle.vin && (
                              <Typography variant="body2" color="textSecondary" style={{ fontFamily: 'monospace' }}>
                                VIN: {vehicle.vin}
                              </Typography>
                            )}
                            {vehicle.registrationExpirationDate && !isUnknown && (
                              <Typography variant="body2" color="textSecondary">
                                Expires: {formatDate(vehicle.registrationExpirationDate)}
                              </Typography>
                            )}
                          </>
                        }
                      />
                      <Box textAlign="right">
                        {isExpired ? (
                          <Chip
                            label={`Expired ${Math.abs(days)}d ago`}
                            style={{ backgroundColor: '#f44336', color: 'white', fontWeight: 600 }}
                          />
                        ) : isUnknown ? (
                          <Chip
                            label={vehicle.registrationLookupFailed ? "Lookup Failed" : "No Date"}
                            style={{ backgroundColor: '#9e9e9e', color: 'white' }}
                            icon={<HelpIcon style={{ color: 'white' }} />}
                          />
                        ) : (
                          <Chip
                            label={`${days} days left`}
                            style={{
                              backgroundColor: days < 15 ? '#f44336' : days < 30 ? '#FF9800' : '#FFC107',
                              color: 'white',
                              fontWeight: 600
                            }}
                          />
                        )}
                      </Box>
                      <Tooltip title="Mark as Sold/Donated">
                        <IconButton
                          size="small"
                          onClick={(e) => handleOpenDisposition(vehicle, e)}
                          style={{ color: '#f44336' }}
                        >
                          <SoldIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </ListItem>
                  );
                })}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRegistrationDialogOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Disposition (Sold/Donated) Dialog */}
      <Dialog
        open={dispositionOpen}
        onClose={() => setDispositionOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <SoldIcon style={{ marginRight: 8, color: '#f44336' }} />
            <Typography variant="h6">
              Mark Equipment as Sold / Donated
            </Typography>
          </Box>
          {dispositionVehicle && (
            <Typography variant="body2" color="textSecondary">
              {dispositionVehicle.name} #{dispositionVehicle.number} — {dispositionVehicle.year} {dispositionVehicle.manufacturer} {dispositionVehicle.model}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} style={{ marginTop: 4 }}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Disposition Type</InputLabel>
                <Select
                  value={dispositionData.dispositionType}
                  onChange={(e) => setDispositionData({ ...dispositionData, dispositionType: e.target.value })}
                  label="Disposition Type"
                >
                  <MenuItem value="Sold">Sold</MenuItem>
                  <MenuItem value="Donated">Donated</MenuItem>
                  <MenuItem value="Scrapped">Scrapped</MenuItem>
                  <MenuItem value="Traded In">Traded In</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="date"
                label="Date"
                variant="outlined"
                value={dispositionData.date}
                onChange={(e) => setDispositionData({ ...dispositionData, date: e.target.value })}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            {(dispositionData.dispositionType === 'Sold' || dispositionData.dispositionType === 'Traded In') && (
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Amount ($)"
                  variant="outlined"
                  type="number"
                  value={dispositionData.amount}
                  onChange={(e) => setDispositionData({ ...dispositionData, amount: e.target.value })}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>
                  }}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={dispositionData.dispositionType === 'Sold' || dispositionData.dispositionType === 'Traded In' ? 6 : 12}>
              <TextField
                fullWidth
                label={dispositionData.dispositionType === 'Donated' ? 'Recipient' : 'Buyer'}
                variant="outlined"
                value={dispositionData.buyer}
                onChange={(e) => setDispositionData({ ...dispositionData, buyer: e.target.value })}
                placeholder={dispositionData.dispositionType === 'Donated' ? 'Who was it donated to?' : 'Who purchased it?'}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Notes"
                variant="outlined"
                value={dispositionData.notes}
                onChange={(e) => setDispositionData({ ...dispositionData, notes: e.target.value })}
                placeholder="Any additional details about the disposition..."
              />
            </Grid>
          </Grid>
          <Alert severity="warning" style={{ marginTop: 16 }}>
            This will deactivate the equipment and remove it from any assigned crews.
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDispositionOpen(false)} disabled={dispositionLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmitDisposition}
            color="secondary"
            variant="contained"
            disabled={dispositionLoading}
            startIcon={dispositionLoading ? <CircularProgress size={16} /> : <SoldIcon />}
          >
            {dispositionLoading ? 'Processing...' : `Mark as ${dispositionData.dispositionType}`}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user
});

export default connect(mapStateToProps)(FleetOverview);
